import { apiClient } from './apiClient';

export type JobPosition = {
  id: string;
  name: string;
  description: string;
  isActive: boolean;
  createdAtUtc: string;
  updatedAtUtc: string;
};

export type JobPositionListResult = {
  items: JobPosition[];
  totalCount: number;
  page: number;
  pageSize: number;
};

export type JobPositionUpsertPayload = {
  name: string;
  description?: string;
  isActive?: boolean;
};

export type JobPositionListFilter = {
  activeOnly?: boolean;
  search?: string;
  page?: number;
  pageSize?: number;
};

export async function listJobPositions(
  filter: JobPositionListFilter = {},
): Promise<JobPositionListResult> {
  const response = await apiClient.get<JobPositionListResult>('/v1/people/job-positions', {
    params: {
      activeOnly: filter.activeOnly ?? false,
      search: filter.search || undefined,
      page: filter.page ?? 1,
      pageSize: filter.pageSize ?? 10,
    },
  });
  return response.data;
}

export async function getJobPosition(id: string): Promise<JobPosition> {
  const response = await apiClient.get<JobPosition>(`/v1/people/job-positions/${id}`);
  return response.data;
}

export async function createJobPosition(payload: JobPositionUpsertPayload): Promise<JobPosition> {
  const response = await apiClient.post<JobPosition>('/v1/people/job-positions', payload);
  return response.data;
}

export async function updateJobPosition(
  id: string,
  payload: JobPositionUpsertPayload,
): Promise<JobPosition> {
  const response = await apiClient.put<JobPosition>(`/v1/people/job-positions/${id}`, payload);
  return response.data;
}

export async function deleteJobPosition(id: string): Promise<void> {
  await apiClient.delete(`/v1/people/job-positions/${id}`);
}
